import { App as AntdApp, Button, Layout, Menu, Space, theme } from "antd";
import Title from "antd/es/typography/Title";
import { LogoutOutlined } from "@ant-design/icons";
import Settings from "$components/Settings";
import { useContext, useState } from "react";
import { AuthContext } from "$context/AuthContextProvider";
const { Header, Content, Footer } = Layout;

const items = [
  {
    key: "1",
    label: "Einstellungen",
    value: (
      <AntdApp>
        <Settings />
      </AntdApp>
    ),
  },
];

function App() {
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();
  const [showContent, setShowContent] = useState(<Settings />);
  const authContext = useContext(AuthContext);
  const onSelect = ({ item, key }) => {
    const selected = items.filter((value) => value.key === key)[0];
    setShowContent(selected.value);
  };

  return (
    <Layout>
      <Header
        style={{
          position: "sticky",
          top: 0,
          zIndex: 1,
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Title level={3} style={{ color: "white" }}>
          Stadtwerk Abschlagsänderung
        </Title>
        <Space align="start">
          <Menu
            theme="dark"
            mode="horizontal"
            defaultSelectedKeys={["1"]}
            items={items}
            style={{
              flex: 1,
              minWidth: 0,
            }}
            onSelect={onSelect}
          />
        </Space>

        <Button
          type="primary"
          icon={<LogoutOutlined />}
          onClick={() => {
            authContext.logout();
          }}
        >
          Logout
        </Button>
      </Header>
      <Content
        key={showContent}
        style={{
          padding: "0 48px",
        }}
      >
        <div
          style={{
            padding: 24,
            minHeight: 380,
            background: colorBgContainer,
            borderRadius: borderRadiusLG,
          }}
        >
          {showContent}
        </div>
      </Content>
      <Footer
        style={{
          textAlign: "center",
        }}
      >
        ©{new Date().getFullYear()} by ENCOMlab
      </Footer>
    </Layout>
  );
}

export default App;
